<template>
  <div class="form-group custom-form-group">
    <label v-if="label" class="custom-form-group-label">{{ label }}</label>
    <span v-if="disclaimer" class="custom-form-group-disclaimer">
      {{ disclaimer }}
    </span>
    <div class="custom-form-group-radio"
         :class="{ 'custom-form-group-radio-wrappable': wrappable,
                   'custom-form-group-radio-vertical': vertical }">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "RadioControlWrapper",
  props: {
    label: { type: String },
    disclaimer: { type: String },
    wrappable: { type: Boolean, default: false },
    vertical: { type: Boolean, default: false }
  }
};
</script>
